module.exports = __webpack_public_path__ + "img/pool_primary_icon.060a18fc.svg";